class CaiProductStory extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enhanced === 'true') return;
    this.dataset.enhanced = 'true';

    if (this.dataset.enableAccordions !== 'true') return;

    const descriptionLength = Number(this.dataset.descriptionLength || 0);
    const minimumLength = Number(this.dataset.minimumLength || 1000);
    if (descriptionLength < minimumLength) return;

    const content = this.querySelector('[data-product-story-content]');
    if (!content) return;

    // Rich-text editors leave empty headings, non-breaking spaces and line breaks.
    // Count media as content so photo/video-only sections are never discarded.
    const meaningfulText = (node) => (node.textContent || '').replace(/[\s\u200B-\u200D\uFEFF]/g, '');
    const hasContent = (node) => {
      if (node.nodeType === Node.TEXT_NODE) return Boolean(meaningfulText(node));
      if (node.nodeType !== Node.ELEMENT_NODE) return false;
      if (/^(SCRIPT|STYLE|TEMPLATE)$/.test(node.tagName)) return false;
      if (/^(IMG|PICTURE|VIDEO|AUDIO|IFRAME|OBJECT|EMBED|SVG|CANVAS|INPUT|SELECT|TEXTAREA|BUTTON)$/.test(node.tagName.toUpperCase())) return true;
      return Array.from(node.childNodes).some(hasContent);
    };
    // Remove empty editor spacer blocks in the rendered copy only.
    // Keep named anchors available to links, even when they contain no text.
    Array.from(content.children).forEach((node) => {
      if (/^(P|H2|H3|H4)$/.test(node.tagName) && !hasContent(node) &&
          !node.id && !node.querySelector('[id], a[name]')) node.remove();
    });
    const directChildren = Array.from(content.children);
    const headings = directChildren.filter((node) => /^(H2|H3|H4)$/.test(node.tagName) && meaningfulText(node));
    if (!headings.length) return;

    let sectionHeadings = headings;
    const firstElement = directChildren.find(hasContent);
    if (firstElement && headings[0] === firstElement) {
      firstElement.classList.add('cai-product-story__lead-heading');
      sectionHeadings = headings.slice(1);
    }

    if (!sectionHeadings.length) return;

    const intro = document.createElement('p');
    intro.className = 'cai-product-story__details-intro';
    intro.textContent = 'Explore the sections below for fitment, included parts, and installation guidance.';
    let introInserted = false;

    sectionHeadings.forEach((heading) => {
      if (!heading.isConnected || heading.parentElement !== content) return;

      // Leave standalone headings visible instead of making an empty toggle.
      const nodes = [];
      let next = heading.nextSibling;
      while (next && !sectionHeadings.includes(next)) {
        nodes.push(next);
        next = next.nextSibling;
      }
      if (!nodes.some(hasContent)) return;
      if (!introInserted) {
        heading.before(intro);
        introInserted = true;
      }

      const details = document.createElement('details');
      details.className = 'cai-product-story__details';

      const summary = document.createElement('summary');
      summary.className = 'cai-product-story__summary';

      const title = document.createElement('span');
      title.className = 'cai-product-story__summary-title';
      title.textContent = heading.textContent.trim();

      const action = document.createElement('span');
      action.className = 'cai-product-story__summary-action';
      action.setAttribute('aria-hidden', 'true');

      const icon = document.createElement('span');
      icon.className = 'cai-product-story__summary-icon';
      icon.setAttribute('aria-hidden', 'true');

      const panel = document.createElement('div');
      panel.className = 'cai-product-story__details-content';

      heading.before(details);
      heading.remove();
      summary.append(title, action, icon);
      details.append(summary, panel);

      nodes.forEach((node) => panel.append(node));
    });
  }
}

if (!customElements.get('cai-product-story')) {
  customElements.define('cai-product-story', CaiProductStory);
}
